import { render, staticRenderFns } from "./Diagnostic.vue?vue&type=template&id=64736c42&scoped=true"
import script from "./Diagnostic.vue?vue&type=script&lang=js"
export * from "./Diagnostic.vue?vue&type=script&lang=js"
import style0 from "./Diagnostic.vue?vue&type=style&index=0&id=64736c42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64736c42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
